export default __webpack_public_path__ + "static/media/edit.2661762e.svg";